/* ============================================================
   TAKENOATS × APPSTLE BUILD-A-BOX
   V20.1
   FILE: assets/takenoats-byob.js

   INTEGRATED FEATURES
   ------------------------------------------------------------
   - Entire box card selects pack + advances automatically
   - No visible Continue buttons
   - Full flavour count automatically advances to Review
   - Going Back from Review does NOT auto-forward
   - Custom Monthly / One-Time frequency cards
   - Dynamic 14 / 28 / 42 subscription plans
   - Subscription benefit messaging
   - Subscriber Rewards formatting
   - Selected Frequency bold
   - Subscriber Rewards bold
   - Contents label INSIDE actual visible left review card
   - Current bundle price black + bold
   - Crossed-out price stays gray
   - Checkout label
   - Individual products informational only
   - Build Your Box CTA on individual product pages
   - Stable/debounced Review mutations
   - Review scroll-jump reduction
   ============================================================ */


window.takenoatsBYOBLoaded = true;


(function () {


  /* ==========================================================
     PRODUCT DATA
     ========================================================== */

  const PRODUCT_DATA = [

    {
      names: [
        'apple pie'
      ],
      protein: 24,
      url:
        '/products/apple-pie-overnight-oats'
    },

    {
      names: [
        "berries n' cream",
        'berries n cream',
        'berries & cream'
      ],
      protein: 26,
      url:
        '/products/berries-cream-overnight-oats'
    },

    {
      names: [
        'mango custard'
      ],
      protein: 25,
      url:
        '/products/mango-custard-superfood-overnight-oats'
    },

    {
      names: [
        'peach cobbler'
      ],
      protein: 25,
      url:
        '/products/peach-cobbler-overnight-oats'
    },

    {
      names: [
        'key lime pie'
      ],
      protein: 25,
      url:
        '/products/key-lime-pie-overnight-oats'
    },

    {
      names: [
        'choco pb&j',
        'choco pbj'
      ],
      protein: 27,
      url:
        '/products/choco-pbj-overnight-oats'
    },

    {
      names: [
        'chocolate almond crunch'
      ],
      protein: 26,
      url:
        '/products/chocolate-almond-crunch-overnight-oats'
    }

  ];


  const BOX_STORAGE_KEY =
    'takenoats-byob-box';


  const BYOB_URL =
    '/apps/subscriptions/bb/cyEeieRP';


  const SUBSCRIPTION_DISCLAIMER =
    'modify, skip or stop your subscription at any time';


  /* ==========================================================
     STATE
     ========================================================== */

  let userHasChosenBox =
    false;


  let boxAdvancePending =
    false;


  let flavourAdvancePending =
    false;


  let lastStep =
    null;


  let lastFlavourCount =
    null;


  let lastTitleSyncStep =
    null;


  let updateTimer =
    null;


  /* ==========================================================
     GENERAL HELPERS
     ========================================================== */

  function cleanText(element) {

    if (!element) {
      return '';
    }


    return (
      element.innerText ||
      element.textContent ||
      ''
    )
      .replace(
        /\s+/g,
        ' '
      )
      .trim();

  }


  function cleanTextLower(element) {

    return cleanText(
      element
    )
      .toLowerCase();

  }


  function normalizeText(text) {

    return (
      text || ''
    )
      .toLowerCase()
      .replace(
        /’/g,
        "'"
      )
      .replace(
        /—/g,
        '-'
      )
      .replace(
        /\s+/g,
        ' '
      )
      .trim();

  }


  function normalizePath(path) {

    return (
      path || ''
    )
      .replace(
        /\/+$/,
        ''
      )
      .toLowerCase();

  }


  function formatMoney(value) {

    if (
      typeof value !==
      'number' ||
      Number.isNaN(
        value
      )
    ) {
      return '';
    }


    return (
      '$' +
      value.toFixed(
        2
      )
    );

  }


  function formatCompactMoney(value) {

    if (
      typeof value !==
      'number' ||
      Number.isNaN(
        value
      )
    ) {
      return '';
    }


    if (
      Math.abs(
        value -
        Math.round(
          value
        )
      ) <
      0.001
    ) {

      return (
        '$' +
        Math.round(
          value
        )
      );

    }


    return (
      '$' +
      value.toFixed(
        2
      )
    );

  }


  function isElementVisible(element) {

    if (
      !element ||
      !element.getBoundingClientRect
    ) {
      return false;
    }


    const rect =
      element.getBoundingClientRect();


    const style =
      window.getComputedStyle(
        element
      );


    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !==
        'none' &&
      style.visibility !==
        'hidden'
    );

  }


  function getProductByName(name) {

    const normalized =
      normalizeText(
        name
      );


    return (
      PRODUCT_DATA.find(
        function (product) {

          return product.names.some(
            function (candidate) {

              return (
                normalizeText(
                  candidate
                ) ===
                normalized
              );

            }
          );

        }
      ) ||
      null
    );

  }


  function getProductByPath(path) {

    const normalized =
      normalizePath(
        path
      );


    return (
      PRODUCT_DATA.find(
        function (product) {

          return (
            normalizePath(
              product.url
            ) ===
            normalized
          );

        }
      ) ||
      null
    );

  }


  /* ==========================================================
     INDIVIDUAL PRODUCT PAGE RULES
     ========================================================== */

  function applySingleProductPageLock() {

    if (
      !document.body
    ) {
      return;
    }


    const product =
      getProductByPath(
        window.location.pathname
      );


    document.body
      .classList
      .toggle(
        'tn-single-product-info-page',
        Boolean(
          product
        )
      );

  }


  function markSingleFlavourCards() {

    document
      .querySelectorAll(
        'a[href]'
      )
      .forEach(
        function (link) {

          let path;


          try {

            path =
              new URL(
                link.href,
                window.location.origin
              )
                .pathname;

          } catch (error) {

            return;

          }


          if (
            !getProductByPath(
              path
            )
          ) {
            return;
          }


          const wrapper =
            link.closest(
              'li.grid__item'
            ) ||
            link.closest(
              '.product-card-wrapper'
            ) ||
            link.closest(
              '.card-wrapper'
            ) ||
            link.closest(
              '.card'
            );


          if (wrapper) {

            wrapper
              .classList
              .add(
                'tn-single-flavour-card'
              );

          }

        }
      );

  }


  function injectProductBYOBCTA() {

    if (
      !document.body ||
      !document.body
        .classList
        .contains(
          'tn-single-product-info-page'
        )
    ) {
      return;
    }


    const info =
      document.querySelector(
        '.product__info-container'
      );


    if (
      !info ||
      info.querySelector(
        '.tn-product-byob-cta-wrap'
      )
    ) {
      return;
    }


    const wrapper =
      document.createElement(
        'div'
      );


    wrapper.className =
      'tn-product-byob-cta-wrap';


    const link =
      document.createElement(
        'a'
      );


    link.className =
      'tn-product-byob-cta';


    link.href =
      BYOB_URL;


    link.textContent =
      'BUILD YOUR BOX →';


    wrapper.appendChild(
      link
    );


    const purchaseArea =
      info.querySelector(
        '.product-form, ' +
        'product-form, ' +
        '.shopify-payment-button'
      );


    if (purchaseArea) {

      purchaseArea
        .insertAdjacentElement(
          'beforebegin',
          wrapper
        );

    } else {

      info.appendChild(
        wrapper
      );

    }

  }


  function applyGlobalStorefrontRules() {

    applySingleProductPageLock();

    markSingleFlavourCards();

    injectProductBYOBCTA();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document
      .addEventListener(
        'DOMContentLoaded',
        applyGlobalStorefrontRules
      );

  } else {

    applyGlobalStorefrontRules();

  }


  window.setTimeout(
    applyGlobalStorefrontRules,
    500
  );


  window.setTimeout(
    applyGlobalStorefrontRules,
    1200
  );


  /* ==========================================================
     STOP IF NOT BYOB
     ========================================================== */

  if (
    !window.location.pathname
      .includes(
        '/apps/subscriptions/bb/'
      )
  ) {
    return;
  }


  document.body
    .classList
    .add(
      'tn-byob-page'
    );


  /* ==========================================================
     ROOT
     ========================================================== */

  function getRoot() {

    return document
      .querySelector(
        '.cyEeieRP.appstle_bundle'
      );

  }


  function removeClassFromAll(
    root,
    className
  ) {

    if (!root) {
      return;
    }


    root
      .querySelectorAll(
        '.' +
        className
      )
      .forEach(
        function (element) {

          element
            .classList
            .remove(
              className
            );

        }
      );

  }


  /* ==========================================================
     TEXT SEARCH
     ========================================================== */

  function textCandidates(root) {

    if (!root) {
      return [];
    }


    return Array.from(
      root.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, ' +
        'p, span, label, div'
      )
    );

  }


  function getLeafMatches(
    root,
    matcher
  ) {

    return textCandidates(
      root
    )
      .filter(
        function (element) {

          return matcher(
            cleanTextLower(
              element
            )
          );

        }
      )
      .filter(
        function (element) {

          return !Array.from(
            element.children
          )
            .some(
              function (child) {

                return matcher(
                  cleanTextLower(
                    child
                  )
                );

              }
            );

        }
      );

  }


  function markExactText(
    root,
    texts,
    className
  ) {

    const targets =
      (
        Array.isArray(
          texts
        )
          ? texts
          : [
              texts
            ]
      )
        .map(
          function (text) {

            return text
              .toLowerCase();

          }
        );


    getLeafMatches(
      root,
      function (value) {

        return targets
          .includes(
            value
          );

      }
    )
      .forEach(
        function (element) {

          element
            .classList
            .add(
              className
            );

        }
      );

  }


  /* ==========================================================
     BOX INFORMATION
     ========================================================== */

  function parseBoxInfo(card) {

    if (!card) {
      return null;
    }


    const text =
      cleanText(
        card
      );


    const packMatch =
      text.match(
        /\b(14|28|42)\s*pack\b/i
      );


    const prices =
      Array.from(
        text.matchAll(
          /\$([0-9,]+(?:\.[0-9]{1,2})?)/g
        )
      );


    if (
      !packMatch ||
      !prices.length
    ) {
      return null;
    }


    const pack =
      Number(
        packMatch[1]
      );


    const currentTotal =
      Number(
        prices[0][1]
          .replace(
            /,/g,
            ''
          )
      );


    let regularTotal =
      null;


    if (
      prices.length >
      1
    ) {

      const second =
        Number(
          prices[1][1]
            .replace(
              /,/g,
              ''
            )
        );


      if (
        second >
        currentTotal
      ) {

        regularTotal =
          second;

      }

    }


    if (
      !regularTotal &&
      currentTotal
    ) {

      regularTotal =
        currentTotal /
        0.8;

    }


    const firstOrderDiscount =
      Math.max(
        0,
        regularTotal -
        currentTotal
      );


    const discountPercent =
      regularTotal
        ? Math.round(
            (
              firstOrderDiscount /
              regularTotal
            ) *
            100
          )
        : 20;


    return {

      pack:
        pack,

      total:
        currentTotal,

      regularTotal:
        regularTotal,

      firstOrderDiscount:
        firstOrderDiscount,

      discountPercent:
        discountPercent,

      perPouch:
        currentTotal /
        pack

    };

  }


  function saveBoxChoice(card) {

    const info =
      parseBoxInfo(
        card
      );


    if (!info) {
      return;
    }


    try {

      sessionStorage
        .setItem(
          BOX_STORAGE_KEY,
          JSON.stringify(
            info
          )
        );

    } catch (error) {

      /* non-critical */

    }

  }


  function getStoredBoxChoice() {

    try {

      const value =
        sessionStorage
          .getItem(
            BOX_STORAGE_KEY
          );


      if (!value) {
        return null;
      }


      return JSON.parse(
        value
      );

    } catch (error) {

      return null;

    }

  }


  /* ==========================================================
     BREADCRUMB
     ========================================================== */

  function cleanBreadcrumb(root) {

    const list =
      root.querySelector(
        '.as-breadcrumb-wrapper nav ol'
      );


    if (!list) {
      return;
    }


    const validSteps =
      [];


    Array.from(
      list.children
    )
      .forEach(
        function (item) {

          item
            .classList
            .remove(
              'tn-breadcrumb-step',
              'tn-breadcrumb-first',
              'tn-breadcrumb-active',
              'tn-breadcrumb-hidden'
            );


          const link =
            item.querySelector(
              'a'
            );


          if (!link) {

            item
              .classList
              .add(
                'tn-breadcrumb-hidden'
              );

            return;

          }


          const text =
            cleanTextLower(
              link
            );


          let label =
            null;


          if (
            text.includes(
              'select box'
            )
          ) {

            label =
              'Select Box';

          }


          if (
            text.includes(
              'choose your flavours'
            ) ||
            text.includes(
              'choose your flavors'
            )
          ) {

            label =
              'Choose Your Flavours';

          }


          if (
            text.includes(
              'review box'
            ) ||
            text.includes(
              'review your box'
            ) ||
            text.includes(
              'review order'
            )
          ) {

            label =
              'Review Box';

          }


          if (!label) {

            item
              .classList
              .add(
                'tn-breadcrumb-hidden'
              );

            return;

          }


          const active =
            link.classList
              .contains(
                'as-text-indigo-600'
              ) ||
            link.classList
              .contains(
                'as-text-blue-600'
              ) ||
            Boolean(
              link.getAttribute(
                'aria-current'
              )
            );


          link
            .querySelectorAll(
              'svg'
            )
            .forEach(
              function (svg) {

                svg.remove();

              }
            );


          link.textContent =
            label;


          item
            .classList
            .add(
              'tn-breadcrumb-step'
            );


          if (active) {

            item
              .classList
              .add(
                'tn-breadcrumb-active'
              );

          }


          validSteps.push(
            item
          );

        }
      );


    if (
      validSteps.length
    ) {

      validSteps[0]
        .classList
        .add(
          'tn-breadcrumb-first'
        );

    }

  }


  /* ==========================================================
     TITLE FINDERS
     ========================================================== */

  function findReviewTitle(root) {

    return (
      Array.from(
        root.querySelectorAll(
          'h1, h2, h3'
        )
      )
        .find(
          function (heading) {

            const text =
              cleanTextLower(
                heading
              );


            return (
              text ===
              'review order' ||
              text ===
              'review your box'
            );

          }
        ) ||
      null
    );

  }


  function findFlavoursTitle(root) {

    const wrapper =
      root.querySelector(
        '.as-choseProduct-title-wrapper'
      );


    if (!wrapper) {
      return null;
    }


    const headings =
      Array.from(
        wrapper.querySelectorAll(
          'h1, h2, h3'
        )
      );


    return (
      headings.find(
        function (heading) {

          const text =
            cleanTextLower(
              heading
            );


          return (
            text.includes(
              'choose your flavours'
            ) ||
            text.includes(
              'choose your flavors'
            )
          );

        }
      ) ||
      headings[0] ||
      null
    );

  }


  /* ==========================================================
     FREQUENCY BUTTON
     ========================================================== */

  function findFrequencyButton(root) {

    return (
      Array.from(
        root.querySelectorAll(
          'button[aria-haspopup="listbox"]'
        )
      )
        .find(
          function (button) {

            const text =
              cleanTextLower(
                button
              );


            return (
              text.includes(
                'monthly subscription'
              ) ||
              text.includes(
                'one time purchase'
              ) ||
              text.includes(
                'one-time purchase'
              )
            );

          }
        ) ||
      null
    );

  }


  /* ==========================================================
     STEP DETECTION
     ========================================================== */

  function detectStep(root) {

    if (
      findReviewTitle(
        root
      )
    ) {

      return 'review';

    }


    if (
      root.querySelector(
        '.as-products'
      )
    ) {

      return 'flavours';

    }


    return 'select';

  }


  function setStepClass(
    root,
    step
  ) {

    root
      .classList
      .remove(
        'tn-step-select',
        'tn-step-flavours',
        'tn-step-review'
      );


    root
      .classList
      .add(
        'tn-step-' +
        step
      );

  }


  /* ==========================================================
     MAIN TITLES
     ========================================================== */

  function markMainTitles(
    root,
    step
  ) {

    removeClassFromAll(
      root,
      'tn-main-flavours-title'
    );


    removeClassFromAll(
      root,
      'tn-main-review-title'
    );


    if (
      step ===
      'flavours'
    ) {

      const title =
        findFlavoursTitle(
          root
        );


      if (title) {

        title
          .classList
          .add(
            'tn-main-flavours-title'
          );

      }

    }


    if (
      step ===
      'review'
    ) {

      const title =
        findReviewTitle(
          root
        );


      if (title) {

        title
          .classList
          .add(
            'tn-main-review-title'
          );

      }

    }

  }


  /* ==========================================================
     TITLE POSITIONING
     ========================================================== */

  function getMainTitle(
    root,
    step
  ) {

    if (
      step ===
      'review'
    ) {

      return findReviewTitle(
        root
      );

    }


    if (
      step ===
      'flavours'
    ) {

      return findFlavoursTitle(
        root
      );

    }


    return root.querySelector(
      'h2.as-single-product-title'
    );

  }


  function synchronizeTitlePosition(
    root,
    step
  ) {

    const title =
      getMainTitle(
        root,
        step
      );


    const header =
      root.querySelector(
        '.as-bab-header-wrapper'
      );


    if (
      !title ||
      !header
    ) {
      return;
    }


    let stage;


    if (
      step ===
      'flavours'
    ) {

      stage =
        root.querySelector(
          '.as-choseProduct-title-wrapper'
        );

    } else {

      stage =
        title.closest(
          '.as-container'
        ) ||
        title.parentElement;

    }


    if (!stage) {
      return;
    }


    root
      .querySelectorAll(
        '.tn-title-stage'
      )
      .forEach(
        function (element) {

          if (
            element !==
            stage
          ) {

            element
              .classList
              .remove(
                'tn-title-stage'
              );


            element.style
              .removeProperty(
                '--tn-title-offset'
              );

          }

        }
      );


    stage
      .classList
      .add(
        'tn-title-stage'
      );


    stage.style
      .setProperty(
        '--tn-title-offset',
        '0px'
      );


    window.requestAnimationFrame(
      function () {

        if (
          !title.isConnected ||
          !stage.isConnected ||
          !header.isConnected
        ) {
          return;
        }


        const style =
          window.getComputedStyle(
            root
          );


        const gap =
          parseFloat(
            style
              .getPropertyValue(
                '--tn-title-gap'
              )
          ) ||
          70;


        const desired =
          header
            .getBoundingClientRect()
            .bottom +
          gap;


        const current =
          title
            .getBoundingClientRect()
            .top;


        const offset =
          Math.round(
            desired -
            current
          );


        stage.style
          .setProperty(
            '--tn-title-offset',
            offset +
            'px'
          );

      }
    );

  }


  /* ==========================================================
     PACK BADGES
     ========================================================== */

  function addPackBadges(
    root,
    step
  ) {

    if (
      step !==
      'select'
    ) {
      return;
    }


    root
      .querySelectorAll(
        '.as-bab-product'
      )
      .forEach(
        function (card) {

          const match =
            cleanText(
              card
            )
              .match(
                /\b(14|28|42)\s*Pack\b/i
              );


          if (!match) {
            return;
          }


          const pack =
            Number(
              match[1]
            );


          let label =
            null;


          if (
            pack ===
            28
          ) {

            label =
              'Most Popular';

          }


          if (
            pack ===
            42
          ) {

            label =
              'Best Deal';

          }


          let badge =
            card.querySelector(
              '.tn-pack-badge'
            );


          if (!label) {

            if (badge) {
              badge.remove();
            }

            return;

          }


          if (!badge) {

            badge =
              document.createElement(
                'div'
              );


            badge.className =
              'tn-pack-badge';


            card.appendChild(
              badge
            );

          }


          badge.textContent =
            label;

        }
      );

  }


  /* ==========================================================
     SELECT BOX PRICES
     ========================================================== */

  function markBoxPrices(
    root,
    step
  ) {

    if (
      step !==
      'select'
    ) {
      return;
    }


    root
      .querySelectorAll(
        '.as-bab-product'
      )
      .forEach(
        function (card) {

          const info =
            parseBoxInfo(
              card
            );


          if (!info) {
            return;
          }


          card
            .querySelectorAll(
              'span, div, p, s, del'
            )
            .forEach(
              function (element) {

                element
                  .classList
                  .remove(
                    'tn-box-current-price',
                    'tn-box-compare-price'
                  );


                const match =
                  cleanText(
                    element
                  )
                    .match(
                      /^\$([0-9,.]+)$/
                    );


                if (!match) {
                  return;
                }


                const amount =
                  Number(
                    match[1]
                      .replace(
                        /,/g,
                        ''
                      )
                  );


                if (
                  Math.abs(
                    amount -
                    info.total
                  ) <
                  0.02
                ) {

                  element
                    .classList
                    .add(
                      'tn-box-current-price'
                    );

                }


                if (
                  Math.abs(
                    amount -
                    info.regularTotal
                  ) <
                  0.02
                ) {

                  element
                    .classList
                    .add(
                      'tn-box-compare-price'
                    );

                }

              }
            );

        }
      );

  }


  /* ==========================================================
     REVIEW LABELS
     ========================================================== */

  function markReviewElements(
    root
  ) {

    removeClassFromAll(
      root,
      'tn-review-subtitle'
    );


    removeClassFromAll(
      root,
      'tn-selected-frequency-label'
    );


    removeClassFromAll(
      root,
      'tn-subscriber-rewards-label'
    );


    removeClassFromAll(
      root,
      'tn-hide-review-section-label'
    );


    markExactText(
      root,
      [
        'check your items and select your required frequency plan',
        'one choice left. make it a habit, or make it once.'
      ],
      'tn-review-subtitle'
    );


    markExactText(
      root,
      'selected frequency',
      'tn-selected-frequency-label'
    );


    markExactText(
      root,
      'subscriber rewards',
      'tn-subscriber-rewards-label'
    );

    markExactText(
    root,
        'subtotal',
        'tn-subtotal-label'
    );

    /*
       Remove Appstle's OUTSIDE Contents / Bundle labels.

       Never hide our internal Contents label.
    */

    getLeafMatches(
      root,
      function (value) {

        return (
          value ===
          'contents' ||
          value ===
          'bundle'
        );

      }
    )
      .forEach(
        function (element) {

          if (
            element.classList
              .contains(
                'tn-review-contents-label'
              )
          ) {
            return;
          }


          element
            .classList
            .add(
              'tn-hide-review-section-label'
            );

        }
      );

  }


  /* ==========================================================
     CONTENTS — ACTUAL VISIBLE LEFT CARD

     Console inspection confirmed structure:

       flavour title
       ↑
       ...
       ↑
       DIV.as-bg-white.as-p-8...

     That DIV is the real white card visible on Review.

     We locate it from an ACTUAL visible flavour title rather
     than relying on .appstle_selected_product_list.
     ========================================================== */

  function findVisibleSelectedFlavourTitle(
    root
  ) {

    const productNames =
      PRODUCT_DATA
        .flatMap(
          function (product) {

            return product.names;

          }
        )
        .map(
          function (name) {

            return normalizeText(
              name
            );

          }
        );


    const candidates =
      Array.from(
        root.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, div, span'
        )
      );


    return (
      candidates.find(
        function (element) {

          if (
            !isElementVisible(
              element
            )
          ) {
            return false;
          }


          const text =
            normalizeText(
              cleanText(
                element
              )
            );


          return productNames
            .includes(
              text
            );

        }
      ) ||
      null
    );

  }


  function findVisibleContentsCard(
    root
  ) {

    const flavourTitle =
      findVisibleSelectedFlavourTitle(
        root
      );


    if (!flavourTitle) {
      return null;
    }


    let current =
      flavourTitle;


    let fallback =
      null;


    while (
      current &&
      current !==
      root
    ) {

      if (
        current.classList
      ) {

        /*
           Diagnostic showed the real card has BOTH:
             as-bg-white
             as-p-8
        */

        if (
          current.classList
            .contains(
              'as-bg-white'
            ) &&
          current.classList
            .contains(
              'as-p-8'
            )
        ) {

          return current;

        }


        /*
           Fallback if Appstle alters padding utility later.
        */

        if (
          !fallback &&
          current.classList
            .contains(
              'as-bg-white'
            )
        ) {

          const rect =
            current
              .getBoundingClientRect();


          if (
            rect.width >
              300 &&
            rect.height >
              80
          ) {

            fallback =
              current;

          }

        }

      }


      current =
        current.parentElement;

    }


    return fallback;

  }


  function ensureReviewContentsLabel(
    root,
    step
  ) {

    if (
      step !==
      'review'
    ) {
      return;
    }


    const contentsCard =
      findVisibleContentsCard(
        root
      );


    if (!contentsCard) {
      return;
    }


    /*
       Find existing Contents label anywhere in the BYOB root.
       We MOVE it if necessary instead of deleting/recreating it.

       This is important for scroll stability.
    */

    let label =
      root.querySelector(
        '.tn-review-contents-label'
      );


    if (!label) {

      label =
        document.createElement(
          'div'
        );


      label.className =
        'tn-review-contents-label';


      label.textContent =
        'Contents';

    }


    /*
       If label is not already inside the correct visible card,
       move it there exactly once.
    */

    if (
      label.parentElement !==
      contentsCard
    ) {

      contentsCard.insertBefore(
        label,
        contentsCard.firstElementChild
      );

    } else if (
      contentsCard.firstElementChild !==
      label
    ) {

      contentsCard.insertBefore(
        label,
        contentsCard.firstElementChild
      );

    }


    /*
       Remove duplicate labels, but keep the correct one.
    */

    root
      .querySelectorAll(
        '.tn-review-contents-label'
      )
      .forEach(
        function (duplicate) {

          if (
            duplicate !==
            label
          ) {

            duplicate.remove();

          }

        }
      );


    /*
       Match Selected Frequency typography exactly.
    */

    const frequencyLabel =
      root.querySelector(
        '.tn-selected-frequency-label'
      );


    if (
      frequencyLabel
    ) {

      const sourceStyle =
        window.getComputedStyle(
          frequencyLabel
        );


      [
        'font-family',
        'font-size',
        'line-height',
        'font-weight',
        'letter-spacing',
        'color'
      ]
        .forEach(
          function (property) {

            label.style
              .setProperty(
                property,
                sourceStyle
                  .getPropertyValue(
                    property
                  ),
                'important'
              );

          }
        );

    }


    label.style
      .setProperty(
        'display',
        'block',
        'important'
      );


    label.style
      .setProperty(
        'width',
        '100%',
        'important'
      );


    label.style
      .setProperty(
        'box-sizing',
        'border-box',
        'important'
      );


    label.style
      .setProperty(
        'margin',
        '0 0 22px 0',
        'important'
      );


    label.style
      .setProperty(
        'padding',
        '0',
        'important'
      );


    label.style
      .setProperty(
        'text-align',
        'left',
        'important'
      );

  }


  /* ==========================================================
     SUBSCRIBER REWARD LINES
     ========================================================== */

  function rebuildRewardLines(
    root
  ) {

    textCandidates(
      root
    )
      .forEach(
        function (element) {

          if (
            element.classList
              .contains(
                'tn-reward-built'
              )
          ) {
            return;
          }


          const text =
            cleanText(
              element
            );


          const match =
            text.match(
              /^After\s+(\d+)\s*(st|nd|rd|th)\s+order,\s*get\s+(\$[\d,.]+\s+off\.?)$/i
            );


          if (!match) {
            return;
          }


          const childMatch =
            Array.from(
              element.children
            )
              .some(
                function (child) {

                  return (
                    cleanText(
                      child
                    ) ===
                    text
                  );

                }
              );


          if (childMatch) {
            return;
          }


          element.textContent =
            '';


          element
            .classList
            .add(
              'tn-reward-line',
              'tn-reward-built'
            );


          const prefix =
            document.createElement(
              'span'
            );


          prefix.className =
            'tn-reward-prefix';


          prefix.appendChild(
            document.createTextNode(
              'After ' +
              match[1]
            )
          );


          const ordinal =
            document.createElement(
              'sup'
            );


          ordinal.className =
            'tn-reward-ordinal';


          ordinal.textContent =
            match[2];


          prefix.appendChild(
            ordinal
          );


          prefix.appendChild(
            document.createTextNode(
              ' order, get '
            )
          );


          const value =
            document.createElement(
              'strong'
            );


          value.className =
            'tn-reward-value';


          value.textContent =
            match[3];


          element.appendChild(
            prefix
          );


          element.appendChild(
            value
          );

        }
      );

  }


  function getHighestFutureDiscount(
    root
  ) {

    let highest =
      0;


    root
      .querySelectorAll(
        '.tn-reward-value'
      )
      .forEach(
        function (element) {

          const match =
            cleanText(
              element
            )
              .match(
                /\$([\d,.]+)/
              );


          if (!match) {
            return;
          }


          const value =
            Number(
              match[1]
                .replace(
                  /,/g,
                  ''
                )
            );


          if (
            !Number.isNaN(
              value
            )
          ) {

            highest =
              Math.max(
                highest,
                value
              );

          }

        }
      );


    return highest;

  }


  /* ==========================================================
     REVIEW CURRENT / COMPARE PRICE
     ========================================================== */

  function markReviewPrices(
    root,
    step
  ) {

    if (
      step !==
      'review'
    ) {
      return;
    }


    const scope =
      root.querySelector(
        '.as-review-bundle-wrapper'
      ) ||
      root.querySelector(
        '.as-review-wrapper'
      ) ||
      root;


    scope
      .querySelectorAll(
        'span, p, div, s, del'
      )
      .forEach(
        function (element) {

          /*
             Ignore our custom frequency cards.
          */

          if (
            element.closest(
              '.tn-frequency-choice-grid'
            )
          ) {
            return;
          }


          const text =
            cleanText(
              element
            );


          if (
            !/^\$[\d,.]+$/
              .test(
                text
              )
          ) {
            return;
          }


          const childHasSamePrice =
            Array.from(
              element.children
            )
              .some(
                function (child) {

                  return (
                    cleanText(
                      child
                    ) ===
                    text
                  );

                }
              );


          if (
            childHasSamePrice
          ) {
            return;
          }


          let crossedOut =
            element.matches(
              's, del, [class*="line-through"]'
            ) ||
            Boolean(
              element.closest(
                's, del, [class*="line-through"]'
              )
            );


          const computed =
            window.getComputedStyle(
              element
            );


          if (
            computed.textDecorationLine &&
            computed.textDecorationLine
              .includes(
                'line-through'
              )
          ) {

            crossedOut =
              true;

          }


          if (
            crossedOut
          ) {

            element
              .classList
              .remove(
                'tn-review-current-price'
              );


            element
              .classList
              .add(
                'tn-review-compare-price'
              );


            element.style
              .setProperty(
                'color',
                'var(--tn-gray-700)',
                'important'
              );


            element.style
              .setProperty(
                'font-weight',
                '400',
                'important'
              );


            return;

          }


          element
            .classList
            .remove(
              'tn-review-compare-price'
            );


          element
            .classList
            .add(
              'tn-review-current-price'
            );


          element.style
            .setProperty(
              'color',
              'var(--tn-black)',
              'important'
            );


          element.style
            .setProperty(
              'font-weight',
              '700',
              'important'
            );

        }
      );

  }


  /* ==========================================================
     SUBSCRIPTION DISCLAIMER
     ========================================================== */

  function deepHideSubscriptionDisclaimer() {

    const visited =
      new Set();


    function scanRoot(
      searchRoot
    ) {

      if (
        !searchRoot ||
        visited.has(
          searchRoot
        ) ||
        !searchRoot.querySelectorAll
      ) {
        return;
      }


      visited.add(
        searchRoot
      );


      Array.from(
        searchRoot.querySelectorAll(
          '*'
        )
      )
        .forEach(
          function (element) {

            if (
              element.shadowRoot
            ) {

              scanRoot(
                element.shadowRoot
              );

            }


            if (
              [
                'SCRIPT',
                'STYLE',
                'TEMPLATE',
                'NOSCRIPT'
              ]
                .includes(
                  element.tagName
                )
            ) {
              return;
            }


            const visibleText =
              (
                element.innerText ||
                ''
              )
                .replace(
                  /\s+/g,
                  ' '
                )
                .trim()
                .toLowerCase();


            if (
              !visibleText.includes(
                SUBSCRIPTION_DISCLAIMER
              )
            ) {
              return;
            }


            const childMatches =
              Array.from(
                element.children
              )
                .some(
                  function (child) {

                    if (
                      [
                        'SCRIPT',
                        'STYLE',
                        'TEMPLATE'
                      ]
                        .includes(
                          child.tagName
                        )
                    ) {
                      return false;
                    }


                    return (
                      (
                        child.innerText ||
                        ''
                      )
                        .replace(
                          /\s+/g,
                          ' '
                        )
                        .trim()
                        .toLowerCase()
                        .includes(
                          SUBSCRIPTION_DISCLAIMER
                        )
                    );

                  }
                );


            if (
              childMatches
            ) {
              return;
            }


            element
              .classList
              .add(
                'tn-hide-subscription-disclaimer'
              );


            element.style
              .setProperty(
                'display',
                'none',
                'important'
              );

          }
        );

    }


    scanRoot(
      document
    );

  }


  /* ==========================================================
     FREQUENCY HELPERS
     ========================================================== */

  function getCurrentFrequencyMode(
    button
  ) {

    const text =
      cleanTextLower(
        button
      );


    if (
      text.includes(
        'monthly subscription'
      )
    ) {

      return 'monthly';

    }


    if (
      text.includes(
        'one time purchase'
      ) ||
      text.includes(
        'one-time purchase'
      )
    ) {

      return 'onetime';

    }


    return null;

  }


  function getCurrentPackNumber(
    button
  ) {

    const stored =
      getStoredBoxChoice();


    if (
      stored &&
      stored.pack
    ) {

      return Number(
        stored.pack
      );

    }


    const match =
      cleanText(
        button
      )
        .match(
          /\b(14|28|42)\s*Pack\b/i
        );


    return (
      match
        ? Number(
            match[1]
          )
        : null
    );

  }


  function findAppstleFrequencyOption(
    mode,
    pack
  ) {

    const options =
      Array.from(
        document.querySelectorAll(
          '[role="option"]'
        )
      );


    if (
      mode ===
      'onetime'
    ) {

      return (
        options.find(
          function (option) {

            return (
              normalizeText(
                cleanText(
                  option
                )
              ) ===
              normalizeText(
                'One Time Purchase'
              )
            );

          }
        ) ||
        null
      );

    }


    if (
      mode ===
      'monthly'
    ) {

      const target =
        'Monthly Subscription — ' +
        pack +
        ' Pack';


      return (
        options.find(
          function (option) {

            return (
              normalizeText(
                cleanText(
                  option
                )
              ) ===
              normalizeText(
                target
              )
            );

          }
        ) ||
        options.find(
          function (option) {

            return (
              normalizeText(
                cleanText(
                  option
                )
              )
                .startsWith(
                  'monthly subscription'
                )
            );

          }
        ) ||
        null
      );

    }


    return null;

  }


  function activateAppstleFrequency(
    root,
    mode
  ) {

    const button =
      findFrequencyButton(
        root
      );


    if (!button) {
      return;
    }


    if (
      getCurrentFrequencyMode(
        button
      ) ===
      mode
    ) {
      return;
    }


    const pack =
      getCurrentPackNumber(
        button
      );


    button.click();


    window.setTimeout(
      function () {

        const option =
          findAppstleFrequencyOption(
            mode,
            pack
          );


        if (option) {

          option.click();


          window.setTimeout(
            updateBYOB,
            170
          );


          return;

        }


        window.setTimeout(
          function () {

            const delayed =
              findAppstleFrequencyOption(
                mode,
                pack
              );


            if (
              delayed
            ) {

              delayed.click();


              window.setTimeout(
                updateBYOB,
                170
              );

            }

          },
          140
        );

      },
      70
    );

  }


  /* ==========================================================
     FREQUENCY UI
     ========================================================== */

  function createBenefitItem(
    text
  ) {

    const item =
      document.createElement(
        'div'
      );


    item.className =
      'tn-benefit-item';


    const check =
      document.createElement(
        'span'
      );


    check.className =
      'tn-benefit-check';


    check.textContent =
      '✓';


    const label =
      document.createElement(
        'span'
      );


    label.textContent =
      text;


    item.appendChild(
      check
    );


    item.appendChild(
      label
    );


    return item;

  }


  function hideNativeFrequencyControl(
    button
  ) {

    if (
      !button ||
      !button.parentElement
    ) {
      return;
    }


    button.parentElement
      .classList
      .add(
        'tn-native-frequency-control'
      );

  }


  function renderFrequencyChoices(
    root,
    step
  ) {

    if (
      step !==
      'review'
    ) {
      return;
    }


    const frequencyButton =
      findFrequencyButton(
        root
      );


    if (!frequencyButton) {
      return;
    }


    const nativeWrapper =
      frequencyButton.parentElement;


    if (!nativeWrapper) {
      return;
    }


    const currentMode =
      getCurrentFrequencyMode(
        frequencyButton
      );


    const box =
      getStoredBoxChoice();


    const firstDiscount =
      box
        ? box.firstOrderDiscount
        : 0;


    const futureDiscount =
      getHighestFutureDiscount(
        root
      );


    const discountPercent =
      (
        box &&
        box.discountPercent
      )
        ? box.discountPercent
        : 20;


    const signature =
      JSON.stringify({

        mode:
          currentMode,

        pack:
          box
            ? box.pack
            : null,

        total:
          box
            ? box.total
            : null,

        regular:
          box
            ? box.regularTotal
            : null,

        future:
          futureDiscount

      });


    let grid =
      root.querySelector(
        '.tn-frequency-choice-grid'
      );


    if (
      grid &&
      grid.dataset.signature ===
      signature
    ) {

      hideNativeFrequencyControl(
        frequencyButton
      );


      return;

    }


    if (grid) {
      grid.remove();
    }


    grid =
      document.createElement(
        'div'
      );


    grid.className =
      'tn-frequency-choice-grid';


    grid.dataset.signature =
      signature;


    /* --------------------------------------------------------
       MONTHLY
       -------------------------------------------------------- */

    const monthly =
      document.createElement(
        'div'
      );


    monthly.className =
      'tn-frequency-choice tn-frequency-monthly';


    if (
      currentMode ===
      'monthly'
    ) {

      monthly
        .classList
        .add(
          'tn-frequency-selected'
        );

    }


    const monthlyButton =
      document.createElement(
        'button'
      );


    monthlyButton.type =
      'button';


    monthlyButton.className =
      'tn-frequency-choice-button';


    const monthlyLeft =
      document.createElement(
        'div'
      );


    monthlyLeft.className =
      'tn-frequency-choice-label-wrap';


    const monthlyRadio =
      document.createElement(
        'span'
      );


    monthlyRadio.className =
      'tn-frequency-radio';


    const monthlyLabel =
      document.createElement(
        'span'
      );


    monthlyLabel.className =
      'tn-frequency-choice-label';


    monthlyLabel.textContent =
      'Monthly Subscription';


    monthlyLeft.appendChild(
      monthlyRadio
    );


    monthlyLeft.appendChild(
      monthlyLabel
    );


    const monthlyPrice =
      document.createElement(
        'div'
      );


    monthlyPrice.className =
      'tn-frequency-choice-price';


    if (box) {

      monthlyPrice.appendChild(
        document.createTextNode(
          formatMoney(
            box.total
          )
        )
      );


      const old =
        document.createElement(
          'span'
        );


      old.className =
        'tn-frequency-old-price';


      old.textContent =
        formatMoney(
          box.regularTotal
        );


      monthlyPrice.appendChild(
        old
      );

    }


    monthlyButton.appendChild(
      monthlyLeft
    );


    monthlyButton.appendChild(
      monthlyPrice
    );


    monthlyButton
      .addEventListener(
        'click',
        function () {

          activateAppstleFrequency(
            root,
            'monthly'
          );

        }
      );


    const badge =
      document.createElement(
        'div'
      );


    badge.className =
      'tn-frequency-save-badge';


    badge.textContent =
      'SAVE ' +
      discountPercent +
      '% ON YOUR FIRST ORDER';


    const benefits =
      document.createElement(
        'div'
      );


    benefits.className =
      'tn-frequency-benefits';


    benefits.appendChild(
      createBenefitItem(
        firstDiscount
          ? (
              formatMoney(
                firstDiscount
              ) +
              ' Off First Order'
            )
          : (
              discountPercent +
              '% Off First Order'
            )
      )
    );


    benefits.appendChild(
      createBenefitItem(
        'Free Shipping'
      )
    );


    benefits.appendChild(
      createBenefitItem(
        futureDiscount
          ? (
              'Up to ' +
              formatCompactMoney(
                futureDiscount
              ) +
              ' Off Future Orders'
            )
          : (
              'Savings On Future Orders'
            )
      )
    );


    benefits.appendChild(
      createBenefitItem(
        'Skip or Cancel Anytime'
      )
    );


    monthly.appendChild(
      badge
    );


    monthly.appendChild(
      monthlyButton
    );


    monthly.appendChild(
      benefits
    );


    /* --------------------------------------------------------
       ONE TIME
       -------------------------------------------------------- */

    const oneTime =
      document.createElement(
        'div'
      );


    oneTime.className =
      'tn-frequency-choice tn-frequency-onetime';


    if (
      currentMode ===
      'onetime'
    ) {

      oneTime
        .classList
        .add(
          'tn-frequency-selected'
        );

    }


    const oneTimeButton =
      document.createElement(
        'button'
      );


    oneTimeButton.type =
      'button';


    oneTimeButton.className =
      'tn-frequency-choice-button';


    const oneTimeLeft =
      document.createElement(
        'div'
      );


    oneTimeLeft.className =
      'tn-frequency-choice-label-wrap';


    const oneTimeRadio =
      document.createElement(
        'span'
      );


    oneTimeRadio.className =
      'tn-frequency-radio';


    const oneTimeLabel =
      document.createElement(
        'span'
      );


    oneTimeLabel.className =
      'tn-frequency-choice-label';


    oneTimeLabel.textContent =
      'One Time Purchase';


    oneTimeLeft.appendChild(
      oneTimeRadio
    );


    oneTimeLeft.appendChild(
      oneTimeLabel
    );


    const oneTimePrice =
      document.createElement(
        'div'
      );


    oneTimePrice.className =
      'tn-frequency-choice-price';


    if (box) {

      oneTimePrice.textContent =
        formatMoney(
          box.regularTotal
        );

    }


    oneTimeButton.appendChild(
      oneTimeLeft
    );


    oneTimeButton.appendChild(
      oneTimePrice
    );


    oneTimeButton
      .addEventListener(
        'click',
        function () {

          activateAppstleFrequency(
            root,
            'onetime'
          );

        }
      );


    oneTime.appendChild(
      oneTimeButton
    );


    /* --------------------------------------------------------
       INSERT
       -------------------------------------------------------- */

    grid.appendChild(
      monthly
    );


    grid.appendChild(
      oneTime
    );


    nativeWrapper
      .insertAdjacentElement(
        'afterend',
        grid
      );


    hideNativeFrequencyControl(
      frequencyButton
    );

  }


  /* ==========================================================
     FLAVOUR CARDS
     ========================================================== */

  function enhanceFlavourCards(
    root
  ) {

    const box =
      getStoredBoxChoice();


    const pouchPrice =
      box
        ? formatMoney(
            box.perPouch
          )
        : '';


    root
      .querySelectorAll(
        '.as-products > .as-product-bab-available'
      )
      .forEach(
        function (card) {

          const cardSection =
            card.querySelector(
              '.as-card-section'
            );


          const buttonSection =
            card.querySelector(
              '.as-card-button-section'
            );


          const title =
            card.querySelector(
              '.as-product-title'
            );


          if (
            !cardSection ||
            !buttonSection ||
            !title
          ) {
            return;
          }


          const product =
            getProductByName(
              cleanText(
                title
              )
            );


          if (!product) {
            return;
          }


          let details =
            card.querySelector(
              '.tn-flavour-details'
            );


          if (!details) {

            details =
              document.createElement(
                'div'
              );


            details.className =
              'tn-flavour-details';


            const price =
              document.createElement(
                'div'
              );


            price.className =
              'tn-flavour-price';


            const protein =
              document.createElement(
                'div'
              );


            protein.className =
              'tn-flavour-protein';


            details.appendChild(
              price
            );


            details.appendChild(
              protein
            );


            title
              .insertAdjacentElement(
                'afterend',
                details
              );

          }


          const price =
            details.querySelector(
              '.tn-flavour-price'
            );


          const protein =
            details.querySelector(
              '.tn-flavour-protein'
            );


          if (price) {

            price.textContent =
              pouchPrice
                ? (
                    pouchPrice +
                    ' / pouch'
                  )
                : '';

          }


          if (protein) {

            protein.textContent =
              product.protein +
              'g protein';

          }


          let info =
            card.querySelector(
              '.tn-more-info-wrap'
            );


          if (!info) {

            info =
              document.createElement(
                'div'
              );


            info.className =
              'tn-more-info-wrap';


            const link =
              document.createElement(
                'a'
              );


            link.className =
              'tn-more-info-link';


            link.textContent =
              'click for more info';


            link.href =
              product.url;


            link.target =
              '_blank';


            link.rel =
              'noopener noreferrer';


            link
              .addEventListener(
                'click',
                function (event) {

                  event
                    .stopPropagation();

                }
              );


            info.appendChild(
              link
            );


            buttonSection
              .insertAdjacentElement(
                'afterend',
                info
              );

          }

        }
      );

  }


  /* ==========================================================
     BUTTON MARKING
     ========================================================== */

  function markCardActions(
    root
  ) {

    removeClassFromAll(
      root,
      'tn-card-action'
    );


    root
      .querySelectorAll(
        '.as-card-button-section button, ' +
        '.as-selection button'
      )
      .forEach(
        function (element) {

          element
            .classList
            .add(
              'tn-card-action'
            );

        }
      );

  }


  /* ==========================================================
     CHECKOUT BUTTON
     ========================================================== */

  function markCartAction(
    root
  ) {

    removeClassFromAll(
      root,
      'tn-cart-action'
    );


    root
      .querySelectorAll(
        'button, a, [role="button"]'
      )
      .forEach(
        function (element) {

          const text =
            cleanTextLower(
              element
            );


          const isCheckout =
            text.includes(
              'add to cart'
            ) ||
            text ===
              'checkout' ||
            text.startsWith(
              'checkout '
            );


          if (
            !isCheckout
          ) {
            return;
          }


          element
            .classList
            .add(
              'tn-cart-action'
            );


          /*
             Appstle now controls actual Checkout redirect.

             We only rename the visible button.
          */

          if (
            text.includes(
              'add to cart'
            )
          ) {

            element.textContent =
              'Checkout';

          }

        }
      );

  }


  /* ==========================================================
     NATIVE CONTINUE
     ========================================================== */

  function getNativeContinue(
    root
  ) {

    if (!root) {
      return null;
    }


    return (
      Array.from(
        root.querySelectorAll(
          'button.as-next-step'
        )
      )
        .find(
          function (button) {

            return cleanTextLower(
              button
            )
              .includes(
                'continue'
              );

          }
        ) ||
      null
    );

  }


  function clickNativeContinue(
    root
  ) {

    const button =
      getNativeContinue(
        root
      );


    if (
      button &&
      !button.disabled
    ) {

      button.click();

      return true;

    }


    return false;

  }


  /* ==========================================================
     SELECT BOX → AUTO ADVANCE
     ========================================================== */

  function advanceFromBoxSelection(
    root
  ) {

    if (
      boxAdvancePending
    ) {
      return;
    }


    boxAdvancePending =
      true;


    function attempt(
      remaining
    ) {

      const currentRoot =
        getRoot();


      if (
        !currentRoot ||
        detectStep(
          currentRoot
        ) !==
        'select'
      ) {

        boxAdvancePending =
          false;

        return;

      }


      const selectedCard =
        currentRoot.querySelector(
          '.as-bab-selected-product'
        );


      if (
        selectedCard
      ) {

        saveBoxChoice(
          selectedCard
        );

      }


      const success =
        clickNativeContinue(
          currentRoot
        );


      if (
        success
      ) {

        window.setTimeout(
          function () {

            boxAdvancePending =
              false;

          },
          500
        );


        return;

      }


      if (
        remaining >
        0
      ) {

        window.setTimeout(
          function () {

            attempt(
              remaining -
              1
            );

          },
          120
        );

      } else {

        boxAdvancePending =
          false;

      }

    }


    window.setTimeout(
      function () {

        attempt(
          4
        );

      },
      120
    );

  }


  function handleSelectCardClick(
    root,
    card,
    event
  ) {

    if (
      boxAdvancePending
    ) {
      return;
    }


    const clickedNativeButton =
      event.target.closest(
        '.as-selection button'
      );


    const selectedAlready =
      card.classList
        .contains(
          'as-bab-selected-product'
        );


    saveBoxChoice(
      card
    );


    userHasChosenBox =
      true;


    root
      .classList
      .remove(
        'tn-awaiting-box-choice'
      );


    if (
      clickedNativeButton
    ) {

      advanceFromBoxSelection(
        root
      );

      return;

    }


    if (
      selectedAlready
    ) {

      advanceFromBoxSelection(
        root
      );

      return;

    }


    const nativeButton =
      card.querySelector(
        '.as-selection button'
      );


    if (
      nativeButton
    ) {

      event.preventDefault();

      event.stopPropagation();


      nativeButton.click();


      advanceFromBoxSelection(
        root
      );


      return;

    }


    advanceFromBoxSelection(
      root
    );

  }


  document
    .addEventListener(
      'click',
      function (event) {

        const root =
          getRoot();


        if (
          !root ||
          detectStep(
            root
          ) !==
          'select'
        ) {
          return;
        }


        const card =
          event.target.closest(
            '.as-bab-product'
          );


        if (
          !card ||
          !root.contains(
            card
          )
        ) {
          return;
        }


        handleSelectCardClick(
          root,
          card,
          event
        );

      },
      true
    );


  /* ==========================================================
     FLAVOUR PROGRESS
     ========================================================== */

  function getFlavourProgress(
    root
  ) {

    const progress =
      root.querySelector(
        '.limit-progress'
      );


    const text =
      progress
        ? cleanText(
            progress
          )
        : cleanText(
            root
          );


    const match =
      text.match(
        /(\d+)\s*\/\s*(14|28|42)\s*Selected/i
      );


    if (!match) {
      return null;
    }


    return {

      selected:
        Number(
          match[1]
        ),

      required:
        Number(
          match[2]
        )

    };

  }


  function autoAdvanceFlavours(
    root,
    step
  ) {

    if (
      step !==
      'flavours'
    ) {

      lastFlavourCount =
        null;


      flavourAdvancePending =
        false;


      return;

    }


    const progress =
      getFlavourProgress(
        root
      );


    if (!progress) {
      return;
    }


    /*
       Arriving from Review via Back:

       If already 28/28, establish baseline but DO NOT
       automatically send them back to Review.
    */

    if (
      lastStep !==
      'flavours' ||
      lastFlavourCount ===
      null
    ) {

      lastFlavourCount =
        progress.selected;


      return;

    }


    const previous =
      lastFlavourCount;


    lastFlavourCount =
      progress.selected;


    const justCompleted =
      previous <
        progress.required &&
      progress.selected ===
        progress.required;


    if (
      !justCompleted ||
      flavourAdvancePending
    ) {
      return;
    }


    flavourAdvancePending =
      true;


    function attempt(
      remaining
    ) {

      const currentRoot =
        getRoot();


      if (
        !currentRoot ||
        detectStep(
          currentRoot
        ) !==
        'flavours'
      ) {

        flavourAdvancePending =
          false;

        return;

      }


      const currentProgress =
        getFlavourProgress(
          currentRoot
        );


      if (
        !currentProgress ||
        currentProgress.selected !==
          currentProgress.required
      ) {

        flavourAdvancePending =
          false;

        return;

      }


      const success =
        clickNativeContinue(
          currentRoot
        );


      if (
        success
      ) {

        window.setTimeout(
          function () {

            flavourAdvancePending =
              false;

          },
          500
        );


        return;

      }


      if (
        remaining >
        0
      ) {

        window.setTimeout(
          function () {

            attempt(
              remaining -
              1
            );

          },
          100
        );

      } else {

        flavourAdvancePending =
          false;

      }

    }


    window.setTimeout(
      function () {

        attempt(
          5
        );

      },
      140
    );

  }


  /* ==========================================================
     MAIN UPDATE
     ========================================================== */

  function updateBYOB() {

    const root =
      getRoot();


    if (!root) {
      return;
    }


    cleanBreadcrumb(
      root
    );


    const step =
      detectStep(
        root
      );


    const stepChanged =
      step !==
      lastStep;


    setStepClass(
      root,
      step
    );


    markMainTitles(
      root,
      step
    );


    addPackBadges(
      root,
      step
    );


    markBoxPrices(
      root,
      step
    );


    markReviewElements(
      root
    );


    rebuildRewardLines(
      root
    );


    markReviewPrices(
      root,
      step
    );


    markCardActions(
      root
    );


    markCartAction(
      root
    );


    enhanceFlavourCards(
      root
    );


    /* --------------------------------------------------------
       REVIEW
       -------------------------------------------------------- */

    if (
      step ===
      'review'
    ) {

      /*
         IMPORTANT ORDER:

         1. identify review labels
         2. locate REAL white left card
         3. insert/move Contents exactly once
      */

      ensureReviewContentsLabel(
        root,
        step
      );


      deepHideSubscriptionDisclaimer();


      renderFrequencyChoices(
        root,
        step
      );


      /*
         Appstle may finish tiny pieces after the main render.
         These are assertions, not full rebuilds.
      */

      window.setTimeout(
        function () {

          const currentRoot =
            getRoot();


          if (
            currentRoot &&
            detectStep(
              currentRoot
            ) ===
            'review'
          ) {

            ensureReviewContentsLabel(
              currentRoot,
              'review'
            );


            markReviewPrices(
              currentRoot,
              'review'
            );


            markCartAction(
              currentRoot
            );


            deepHideSubscriptionDisclaimer();

          }

        },
        220
      );

    }


    /* --------------------------------------------------------
       AUTO ADVANCE FLAVOURS
       -------------------------------------------------------- */

    autoAdvanceFlavours(
      root,
      step
    );


    /*
       TITLE POSITION

       Do NOT repeatedly recalculate on every Review mutation.

       Only:
       - entering a new step
       - first sync
       - resize handler below
    */

    if (
      stepChanged ||
      lastTitleSyncStep !==
      step
    ) {

      synchronizeTitlePosition(
        root,
        step
      );


      lastTitleSyncStep =
        step;

    }


    lastStep =
      step;

  }


  /* ==========================================================
     STABLE MUTATION HANDLING
     ========================================================== */

  function queueUpdate() {

    if (
      updateTimer
    ) {

      window.clearTimeout(
        updateTimer
      );

    }


    const root =
      getRoot();


    const step =
      root
        ? detectStep(
            root
          )
        : null;


    /*
       Review is React-heavy.

       Waiting until Appstle settles prevents:
       - scroll anchoring fights
       - repeated height changes
       - Contents being inserted during intermediate layouts
       - frequency UI being processed mid-render
    */

    const delay =
      step ===
      'review'
        ? 180
        : 40;


    updateTimer =
      window.setTimeout(
        function () {

          updateTimer =
            null;


          updateBYOB();

        },
        delay
      );

  }


  /* ==========================================================
     START
     ========================================================== */

  function observeRoot(
    root
  ) {

    const observer =
      new MutationObserver(
        queueUpdate
      );


    observer.observe(
      root,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }


  function startWhenReady() {

    const root =
      getRoot();


    if (root) {

      updateBYOB();


      observeRoot(
        root
      );


      return;

    }


    const pageObserver =
      new MutationObserver(
        function () {

          const current =
            getRoot();


          if (!current) {
            return;
          }


          pageObserver.disconnect();


          updateBYOB();


          observeRoot(
            current
          );

        }
      );


    pageObserver.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }


  /* ==========================================================
     RESIZE
     ========================================================== */

  window
    .addEventListener(
      'resize',
      function () {

        const root =
          getRoot();


        if (!root) {
          return;
        }


        const step =
          detectStep(
            root
          );


        synchronizeTitlePosition(
          root,
          step
        );


        lastTitleSyncStep =
          step;

      }
    );


  /* ==========================================================
     START
     ========================================================== */

  startWhenReady();


  window.takenoatsBYOBRefresh =
    updateBYOB;


})();